import React from 'react';

import {useStore} from 'effector-react';

import {useTranslation} from 'react-i18next';

import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {transactionsBalance$} from 'models/profile/billing';
import {billingAccess$} from 'models/profile/billing/access';

import {TableSearch} from '../TableInvoces/SearchFilter';

import {BalanceContainer, Root, SearchContainer} from './styled';

export const BillingHeaderControl = ({
    setShowInvoiceGeneratingModal,
    isSearchable,
}: {
    isSearchable?: boolean;
    setShowInvoiceGeneratingModal?: (show: boolean) => void;
}) => {
    const {t, i18n} = useTranslation();
    const balance = useStore(transactionsBalance$);
    const formattedBalance = new Intl.NumberFormat(i18n.language, {
        maximumFractionDigits: 2,
    }).format(balance);
    const access = useStore(billingAccess$);
    return (
        <Root>
            {isSearchable ? (
                <SearchContainer>
                    {access.canViewInvoices ? (
                        <>
                            <TableSearch searchField="irn" />
                            <TableSearch searchField="tin" />
                        </>
                    ) : (
                        <TableSearch searchField="id" />
                    )}
                </SearchContainer>
            ) : (
                <BalanceContainer>
                    {t('pages.profile.billing.current')}: {formattedBalance}
                </BalanceContainer>
            )}
            <div>
                {!isSearchable && access.canRequestInvoice && (
                    <Button
                        variant={ButtonVariant.Normal}
                        size="sm"
                        type="button"
                        onClick={() => setShowInvoiceGeneratingModal?.(true)}
                    >
                        + {t('pages.profile.billing.invoiceGenerating.buttons.buyCodes')}
                    </Button>
                )}
            </div>
        </Root>
    );
};
